var $0559ac2e41ab1432$exports = {};
$0559ac2e41ab1432$exports = {
    "info": `Informationen`,
    "negative": `Fehler`,
    "notice": `Warnung`,
    "positive": `Erfolg`
};


export {$0559ac2e41ab1432$exports as default};
//# sourceMappingURL=de-DE.mjs.map
